
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 11.27A2.26 2.26 0 005.25 9 2.26 2.26 0 003 6.729a2.26 2.26 0 00-2.25 2.27A2.26 2.26 0 003 11.272zM3 18a2.26 2.26 0 002.25-2.271A2.26 2.26 0 003 13.458a2.26 2.26 0 00-2.25 2.271A2.26 2.26 0 003 18zM3 4.542a2.26 2.26 0 002.25-2.271A2.26 2.26 0 003 0 2.26 2.26 0 00.75 2.271 2.26 2.26 0 003 4.542z"}})])
          )
        }
      }
    